import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { countriesCode } from "src/app/types/counties";

const useCountriesOptions = () => {
    const [countriesOptions, setContriesOptions] = useState<Array<SimpleFormSelectOption>>([]);
    const [loading, setLoading] = useState(true);
    const { formatMessage } = useIntl();

    useEffect(() => {
        setLoading(true);
        const countriesListBuilder: Array<SimpleFormSelectOption> = [];
        countriesCode.forEach((country) => {
            countriesListBuilder.push({
                value: country,
                label: formatMessage({
                    id: `common.field.country.country.${country}`,
                }),
            });
        });
        setContriesOptions(countriesListBuilder);
        setLoading(false);
    }, []);

    return { countriesOptions, loading };
};

export default useCountriesOptions;
